module.exports = __webpack_public_path__ + "static/twitterSummaryX-697a3ee6cbedcbe27c49f0d994cc1552.jpg";